<template>
  <subject-form
    v-model="form"
    :max="chapter.ordered_subjects_ids.length + 1"
    class="max-w-3xl bg-white"
    @submit="submit"
  >
    <div class="flex items-center justify-end border-t px-8 py-4">
      <loading-button
        :loading="loading"
        :progress="loadingProgress"
        class="btn-teal"
        type="submit"
      >
        Create Subject
      </loading-button>
    </div>
  </subject-form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import SubjectForm from './Form.vue';
import axios from 'axios';

export default {
  components: {
    LoadingButton,
    SubjectForm,
  },
  props: {
    chapter: {
      type: Object,
      required: true,
    },
  },
  emits: ['success'],
  data() {
    return {
      form: this.$inertia.form({
        subject: {
          type: 'VideoSubject',
          texts: [],
        },
        video: null,
        poster: null,
        documents: [],
        quiz_questions: [],
        position: this.chapter.ordered_subjects_ids.length + 1,
      }),
      loading: false,
      loadingProgress: 0,
    };
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        let self = this;
        await axios.post(
          this.$routes.chapter_subjects(this.chapter.id),
          { format: 'json', ...this.form },
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: function (progressEvent) {
              self.loadingProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            },
          },
        );
        this.loading = false;
        this.form.reset('subject');
        this.$emit('success');
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
        this.loadingProgress = 0;
      }
    },
  },
};
</script>
